const breadcrumbScrollToggle = () => {
  const MOBILE_MEDIA = "(max-width: 768px)";
  const breadcrumbs = document.querySelectorAll(".js-scroll-breadcrumb");
  if (!breadcrumbs.length) return;

  const update = () => {
    const isMobile = window.matchMedia(MOBILE_MEDIA).matches;

    breadcrumbs.forEach((breadcrumb) => {
      const items = breadcrumb.querySelectorAll(".c-breadcrumb__item");
      if (!items.length) {
        breadcrumb.classList.remove("is-scroll");
        return;
      }

      if (!isMobile) {
        breadcrumb.classList.remove("is-scroll");
        return;
      }

      const totalWidth = Array.from(items).reduce((sum, item) => {
        const style = window.getComputedStyle(item);
        const marginLeft = parseFloat(style.marginLeft) || 0;
        const marginRight = parseFloat(style.marginRight) || 0;
        return (
          sum + item.getBoundingClientRect().width + marginLeft + marginRight
        );
      }, 0);

      const breadcrumbWidth = breadcrumb.clientWidth;

      breadcrumb.classList.toggle("is-scroll", totalWidth > breadcrumbWidth);
    });
  };

  update();
};
